<script>
export default {
  name: "TapCoinResult",
  props: {
    variant: { type: String, default: "info" },
    title: { type: String, required: true },
    message: { type: String, required: true },
    reward: { type: Number, default: 0 },
    balance: { type: Number, default: 0 },
    showReward: { type: Boolean, default: false },
    canRetry: { type: Boolean, default: false },
    retryLabel: { type: String, default: "ลองอีกครั้ง" },
    closeLabel: { type: String, default: "ปิดหน้าต่าง" }
  },
  computed: {
    formattedReward() {
      return Number(this.reward || 0).toLocaleString();
    },
    formattedBalance() {
      return Number(this.balance || 0).toLocaleString();
    }
  }
};
</script>

<template>
  <section class="result-card" :class="`result-card--${variant}`">
    <div class="result-card__icon" aria-hidden="true">
      <span v-if="variant === 'success'">✓</span>
      <span v-else-if="variant === 'warning'">!</span>
      <span v-else-if="variant === 'error'">×</span>
      <span v-else>i</span>
    </div>
    <h2 class="result-card__title">{{ title }}</h2>
    <p class="result-card__message">{{ message }}</p>

    <div v-if="showReward" class="reward-panel">
      <span class="reward-panel__label">เหรียญที่ได้รับ</span>
      <strong class="reward-panel__value">+{{ formattedReward }}</strong>
      <span class="reward-panel__balance"
        >ยอดรวม {{ formattedBalance }} เหรียญ</span
      >
    </div>

    <div class="result-card__actions">
      <button
        v-if="canRetry"
        type="button"
        class="result-button result-button--primary"
        @click="$emit('retry')"
      >
        {{ retryLabel }}
      </button>
      <button type="button" class="result-button" @click="$emit('close')">
        {{ closeLabel }}
      </button>
    </div>
  </section>
</template>

<style scoped>
.result-card {
  width: min(100%, 410px);
  padding: 30px 24px 26px;
  color: #fff;
  text-align: center;
  border: 1px solid rgba(255, 255, 255, 0.11);
  border-radius: 28px;
  background: linear-gradient(
    165deg,
    rgba(34, 17, 58, 0.98),
    rgba(9, 7, 28, 0.98)
  );
  box-shadow: 0 26px 90px rgba(4, 0, 20, 0.66),
    inset 0 1px 0 rgba(255, 255, 255, 0.07);
}

.result-card__icon {
  display: grid;
  width: 74px;
  height: 74px;
  margin: 0 auto 18px;
  color: #1b0c32;
  place-items: center;
  border-radius: 50%;
  background: linear-gradient(145deg, #fff3a8, #ffad35);
  box-shadow: 0 0 34px rgba(255, 170, 45, 0.42);
}

.result-card__icon span {
  font-size: 40px;
  line-height: 1;
  font-weight: 1000;
}
.result-card--warning .result-card__icon {
  color: #391407;
  background: linear-gradient(145deg, #ffe7a2, #ff7544);
}
.result-card--error .result-card__icon {
  color: #fff;
  background: linear-gradient(145deg, #ff7687, #c9255f);
}
.result-card--info .result-card__icon {
  color: #081b32;
  background: linear-gradient(145deg, #a8f2ff, #568dff);
}
.result-card__title {
  margin: 0;
  color: #fff5cf;
  font-size: 25px;
  font-weight: 900;
}
.result-card__message {
  margin: 10px auto 0;
  max-width: 320px;
  color: #bdb5ca;
  font-size: 14px;
  line-height: 1.55;
}

.reward-panel {
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 22px;
  padding: 18px;
  border: 1px solid rgba(255, 197, 75, 0.26);
  border-radius: 20px;
  background: linear-gradient(
    135deg,
    rgba(255, 179, 47, 0.12),
    rgba(144, 73, 255, 0.11)
  );
}

.reward-panel__label {
  color: #a79eb7;
  font-size: 12px;
}
.reward-panel__value {
  margin-top: 3px;
  color: #ffd466;
  font-size: 54px;
  line-height: 1.05;
  font-weight: 1000;
  text-shadow: 0 0 28px rgba(255, 174, 49, 0.4);
}
.reward-panel__balance {
  margin-top: 8px;
  color: #e2dcf0;
  font-size: 13px;
}
.result-card__actions {
  display: flex;
  align-items: stretch;
  flex-direction: column;
  gap: 10px;
  margin-top: 24px;
}
.result-button {
  min-height: 48px;
  padding: 12px 22px;
  color: #d9d1e8;
  font-size: 15px;
  font-weight: 800;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.07);
  cursor: pointer;
}
.result-button--primary {
  color: #210d31;
  border: 0;
  background: linear-gradient(135deg, #ffda67, #ff9b35);
  box-shadow: 0 10px 28px rgba(255, 142, 42, 0.25);
}
.result-button:active {
  transform: translateY(1px) scale(0.99);
}
</style>
